module.exports = __webpack_public_path__ + "img/hero-woman.ed3e0cd5.svg";